import { RMRectangle } from 'business/models/CustomModels';
import Konva from 'konva';

export interface PlatePosition {
  colPos: number;
  rowPos: number;
}

export interface PlateStructure {
  startX: number;
  startY: number;
  availableWidth: number;
  availableHeight: number;
  width: number;
  height: number;
  stx: number;
  sty: number;
  endx: number;
  endy: number;
  wellRects: RMRectangle[];
  wellRectsPadded: RMRectangle[];
}

export enum FrequentlyUsedPlateSize {
  small = 96,
  medium = 384,
  max = 1536,
}
export type WellSelectionMouseEvents = {
  onMouseDown: (evt: Konva.KonvaEventObject<MouseEvent>) => void;
  onMouseMove: (evt: Konva.KonvaEventObject<MouseEvent>) => void;
  getWellSelectionDetails: (evt: Konva.KonvaEventObject<MouseEvent>) => {
    selectedWellNumbers: number[];
    appendSelection: boolean;
  };
};

export interface SizeDetails {
  widthMainDiv?: number;
  canvasWidth: number;
  canvasHeight: number;
}

export type Rectangle = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export const TotalColumns = 12;

export interface PlateCanvasLabels {
  rowLabels: string[];
  columnLabels: string[];
}
